import { render } from "./title.vue?vue&type=template&id=06b0e136&scoped=true"
import script from "./title.vue?vue&type=script&lang=ts"
export * from "./title.vue?vue&type=script&lang=ts"

import "./title.vue?vue&type=style&index=0&id=06b0e136&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-06b0e136"

export default script